<template>
    <!-- 
        carga => Tamanho do campo
        series => blocos
        group => Relacao numerica
    -->
    <div class="col-12 p-4 row justify-content-center">
        <h2 class="title col-12">
            {{ t("new-general.video-session-create") }}
        </h2>
        <div class="col-12 card card-outline card-primary p-2" v-if="!loading">
            <form
                @submit.prevent="submit"
                class="row flex-wrap col-12"
                ref="abc"
            >
                <div class="col-12 p-2">
                    <div
                        class="row p-o m-0 justify-content-between align-items-center"
                    >
                        <InputColor
                            v-model:pure-color="treino.colors.title[0]"
                            style="width: 2rem; height: 2rem"
                        />

                        <input
                            type="text"
                            v-model="treino.title"
                            class="form-control"
                            :placeholder="t('gifs.title')"
                            style="
                                flex: 1 !important;
                                text-align: center;
                                text-transform: uppercase;
                            "
                            :style="{
                                backgroundColor: treino.colors.title[0],
                                color: treino.colors.title[1],
                            }"
                            required
                        />

                        <InputColor
                            v-model:pure-color="treino.colors.title[1]"
                            style="width: 2rem; height: 2rem"
                        />
                    </div>
                </div>
                <div
                    class="col-12 row m-0 p-0 gap-1"
                    :class="{ 'col-md-12': forms == 1, 'col-md-6': forms > 1 }"
                    v-for="i in forms"
                    :key="i"
                >
                    <h5 class="h5 text-bold col-12" v-if="forms > 1">
                        {{ t("new.ex" + i) }}
                    </h5>
                    <div class="col-12 col-md-7">
                        <!-- duration	charge	series	group	 -->
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.duration[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_duration' + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    :placeholder="
                                        t(
                                            isProfile
                                                ? 'student-profile.duration'
                                                : 'gifs.duration',
                                        )
                                    "
                                    v-model="fillVar(i)['h_duration']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.duration[0],
                                        color: fillVar(i).colors.duration[1],
                                    }"
                                />
                                <label
                                    :for="'h_duration' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.duration[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>

                            <input
                                type="text"
                                v-model="fillVar(i)['duration']"
                                class="form-control"
                                required
                                :placeholder="
                                    t(
                                        isProfile
                                            ? 'student-profile.duration'
                                            : 'gifs.duration',
                                    )
                                "
                            />
                        </div>
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.charge[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_charge' + i"
                                    :placeholder="
                                        t(
                                            isProfile
                                                ? 'student-profile.charge'
                                                : 'new-general.video-session-charge',
                                        )
                                    "
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    v-model="fillVar(i)['h_charge']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.charge[0],
                                        color: fillVar(i).colors.charge[1],
                                    }"
                                />
                                <label
                                    :for="'h_charge' + 1"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.charge[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <input
                                type="text"
                                v-model="fillVar(i)['charge']"
                                class="form-control"
                                required
                                :placeholder="
                                    t(
                                        isProfile
                                            ? 'student-profile.charge'
                                            : 'new-general.video-session-charge',
                                    )
                                "
                            />
                        </div>
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.series[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_series' + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    :placeholder="
                                        t(
                                            isProfile
                                                ? 'student-profile.series'
                                                : 'new-general.blocks',
                                        )
                                    "
                                    v-model="fillVar(i)['h_series']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.series[0],
                                        color: fillVar(i).colors.series[1],
                                    }"
                                />
                                <label
                                    :for="'h_series' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.series[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <input
                                type="text"
                                v-model="fillVar(i)['series']"
                                class="form-control"
                                required
                                :placeholder="
                                    t(
                                        isProfile
                                            ? 'student-profile.series'
                                            : 'new-general.blocks',
                                    )
                                "
                            />
                        </div>
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.group[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_group' + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    :placeholder="
                                        t(
                                            isProfile
                                                ? 'student-profile.group'
                                                : 'treinos.exercices.relation',
                                        )
                                    "
                                    v-model="fillVar(i)['h_group']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.group[0],
                                        color: fillVar(i).colors.group[1],
                                    }"
                                />
                                <label
                                    :for="'h_group' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.group[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <input
                                type="text"
                                v-model="fillVar(i)['group']"
                                class="form-control"
                                required
                                :placeholder="
                                    t(
                                        isProfile
                                            ? 'student-profile.group'
                                            : 'treinos.exercices.relation',
                                    )
                                "
                            />
                        </div>
                        <template v-if="isProfile">
                            <div class="px-2 col-12 pt-0">
                                <div
                                    class="row p-0 m-0 py-1 justify-content-between align-items-center"
                                >
                                    <InputColor
                                        v-model:pure-color="
                                            fillVar(i).colors.imc[0]
                                        "
                                        style="width: 2rem; height: 2rem"
                                    />

                                    <input
                                        :id="'h_imc' + i"
                                        maxlength="20"
                                        class="edit col-10 border-none text-bold"
                                        :placeholder="t('student-profile.imc')"
                                        v-model="fillVar(i)['h_imc']"
                                        style="
                                            flex: 1 !important;
                                            text-align: center;
                                        "
                                        :style="{
                                            backgroundColor:
                                                fillVar(i).colors.imc[0],
                                            color: fillVar(i).colors.imc[1],
                                        }"
                                    />
                                    <label
                                        :for="'h_imc' + i"
                                        role="button"
                                        class="fa fa-edit"
                                    ></label>

                                    <InputColor
                                        v-model:pure-color="
                                            fillVar(i).colors.imc[1]
                                        "
                                        style="width: 2rem; height: 2rem"
                                    />
                                </div>
                                <input
                                    type="text"
                                    v-model="fillVar(i)['imc']"
                                    class="form-control"
                                    required
                                    :placeholder="t('student-profile.imc')"
                                />
                            </div>
                            <div class="px-2 col-12 pt-0">
                                <div
                                    class="row p-0 m-0 py-1 justify-content-between align-items-center"
                                >
                                    <InputColor
                                        v-model:pure-color="
                                            fillVar(i).colors.magra[0]
                                        "
                                        style="width: 2rem; height: 2rem"
                                    />

                                    <input
                                        :id="'h_magra' + i"
                                        maxlength="20"
                                        class="edit col-10 border-none text-bold"
                                        :placeholder="
                                            t('student-profile.magra')
                                        "
                                        v-model="fillVar(i)['h_magra']"
                                        style="
                                            flex: 1 !important;
                                            text-align: center;
                                        "
                                        :style="{
                                            backgroundColor:
                                                fillVar(i).colors.magra[0],
                                            color: fillVar(i).colors.magra[1],
                                        }"
                                    />
                                    <label
                                        :for="'h_magra' + i"
                                        role="button"
                                        class="fa fa-edit"
                                    ></label>

                                    <InputColor
                                        v-model:pure-color="
                                            fillVar(i).colors.magra[1]
                                        "
                                        style="width: 2rem; height: 2rem"
                                    />
                                </div>
                                <input
                                    type="text"
                                    v-model="fillVar(i)['magra']"
                                    class="form-control"
                                    required
                                    :placeholder="t('student-profile.magra')"
                                />
                            </div>
                        </template>
                    </div>
                    <div
                        class="col-12 col-md-5 position-relative overflow-auto"
                        style="min-height: 4rem"
                    >
                        <video
                            v-if="selectedVideo"
                            controls
                            muted
                            :src="selectedVideo.url"
                            class="col-12"
                        >
                            Video nao suportado
                        </video>
                        <button
                            class="btn btn-warning position-absolute text-white bottom-0 right-0"
                            type="button"
                            @click="() => openModal(i)"
                        >
                            <i class="fa fa-video"></i>
                        </button>
                    </div>
                    <div class="col-12">
                        <div class="col-12 p-2">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.description[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :placeholder="t('treinos.description')"
                                    :id="'h_objectives' + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    v-model="fillVar(i)['h_objectives']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.description[0],
                                        color: fillVar(i).colors.description[1],
                                    }"
                                />
                                <label
                                    :for="'h_objectives' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.description[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <textarea
                                class="form-control"
                                rows="5"
                                :name="'objetivos' + i"
                                v-model="fillVar(i)['objectives']"
                                maxlength="800"
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="py-2">
                        <button class="btn btn-success mx-2" type="submit">
                            {{ t("treinos.create") }}
                        </button>
                        <button
                            class="btn btn-warning mx-2"
                            @click="back"
                            type="button"
                        >
                            <i class="fa fa-arrow-left mr-2"></i>
                            {{ t("general.back") }}
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <modal-component
            @hide="showModal = false"
            :show="showModal"
            :classList="['col-12']"
            :title="t('new-general.select-video')"
        >
            <div class="row m-0 p-1">
                <template v-for="(video, i) in this.videos" :key="i">
                    <div class="p-2 file-container col-4 col-md-3">
                        <div class="col-12 video-container m-0 p-0">
                            <video
                                :src="video.url"
                                controls
                                muted
                                class="col-12"
                            ></video>
                        </div>
                        <button
                            class="btn btn-block small mutted bg-success p-0 m-0 text-center text-capitalize"
                            @click="() => select(video)"
                        >
                            {{ video.clube }}
                        </button>
                    </div>
                </template>
            </div>
        </modal-component>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { t } from "@/lang";
import Api from "@/utilities/Api";
import ModalComponent from "@/components/AdminLTE/Components/ModalComponent.vue";
import InputColor from "@/components/InputColor.vue";
import { getExImage } from "@/utilities/HelpFunctions.js";

export default {
    name: "NewVideoExView",
    data() {
        return {
            images: [],
            showModal: false,
            isProfile: false,
            treino: {
                title: "",

                duration: "",
                charge: "",
                series: "",
                group: "",
                objectives: "",
                imc: "",
                magra: "",
                usergif: false,
                userGifUrl: null,

                h_duration: t("gifs.duration"),
                h_charge: t("new-general.video-session-charge"),
                h_series: t("new-general.blocks"),
                h_group: t("treinos.exercices.relation"),
                h_objectives: t("treinos.description"),
                h_imc: t("student-profile.imc"),
                h_magra: t("student-profile.magra"),
                path: null,
                fitnes_id: null,
                child: null,

                colors: {
                    title: ["#808080", "#333333"],
                    duration: ["#d0d0d0", "#000000"],
                    charge: ["#d0d0d0", "#000000"],
                    series: ["#d0d0d0", "#000000"],
                    group: ["#d0d0d0", "#000000"],
                    imc: ["#d0d0d0", "#000000"],
                    magra: ["#d0d0d0", "#000000"],
                    description: ["#d0d0d0", "#000000"],
                },
            },
            selectedVideo: null,
            selected: 1,
            forms: 1,
            videos: [],
        };
    },
    components: {
        ModalComponent,
        InputColor,
    },
    async created() {
        this.SET_LOADING(true);
        document.title = t("gifs.new-ex");
        const fn1 = () =>
            new Promise((resolve) => {
                this.getTreino().then(() => resolve());
            });
        const fn2 = () =>
            new Promise((resolve) => {
                this.getVideos().then(() => resolve());
            });

        await Promise.all([fn1(), fn2()]);
        this.SET_LOADING(false);
    },
    computed: {
        ...mapState(["loading"]),
        imgs() {
            return {
                1: `${Api.url}images/GIFS/${this.treino.path}`,
                2: this.treino.child
                    ? `${Api.url}images/GIFS/${this.treino.child.path}`
                    : "",
            };
        },
        imgs2() {
            return {
                1: this.treino.userGifUrl,
                2: this.treino.child ? this.treino.child.userGifUrl : "",
            };
        },
    },
    methods: {
        ...mapActions(["get", "post", "put", "delete"]),
        ...mapMutations(["SET_LOADING"]),
        t,
        back() {
            this.$router.push("/video-sessions/" + this.treino.fitnes_id);
        },
        createUrl(blob) {
            return URL.createObjectURL(blob);
        },
        select(video) {
            this.selectedVideo = video;
            this.showModal = false;
            this.fillVar(this.selected).path = video.id;
            this.fillVar(this.selected).usergif = true;
        },

        async getTreino() {
            this.treino.fitnes_id = this.$route.params.id;
            const response = await this.get({
                url: "fitnesex/" + this.treino.fitnes_id,
            });
            if (response.status == 200) {
                if (!response.data.fitnes.is_video) {
                    alert("Nao encontrado");
                    this.$router.push("/video-sessions");
                }
            } else if (response.status == 401) {
                this.SET_USER(null);
                this.$router.push("/login");
            } else if (response.status == 404) {
                alert("Nao encontrado");
                this.$router.push("/video-sessions");
            } else {
                alert(response.data.message);
            }
        },
        async getVideos() {
            const response = await this.get({ url: "formactions?type=video" });
            if (response.status == 200) {
                this.videos = response.data.formacoes;
                // carregar cada video
                await Promise.all(
                    this.videos.map(
                        (video) =>
                            new Promise((resolve) =>
                                getExImage(
                                    "",
                                    this.get,
                                    `formactionimg/${video.id}?key_time=${Date.now()}`,
                                    "video/webm",
                                ).then((res) => {
                                    video.url = res;
                                    resolve();
                                }),
                            ),
                    ),
                );
            } else if (response.status == 401) {
                this.SET_USER(null);
                this.$router.push("/login");
            } else {
                alert(response.data.message);
            }
        },
        openModal(i) {
            this.selected = i;
            this.showModal = true;
        },
        fillVar(i) {
            return i == 1 ? this.treino : this.treino.child;
        },
        async submit() {
            if (!this.isProfile) {
                if (
                    !this.treino.path ||
                    (this.treino.child && !this.treino.child.path)
                ) {
                    alert(t("gifs.select"));
                    return null;
                }
            }
            this.SET_LOADING(true);

            const fields = {
                path: "path",
                duration: "duration",
                charge: "charge",
                imc: "imc",
                series: "series",
                group: "group",
                description: "objectives",
                magra: "magra",
            };

            const frmDt = new FormData();
            frmDt.append("title", this.treino.title);

            for (let key in fields) {
                frmDt.append(key, this.treino[fields[key]]);
                frmDt.append(`h_${key}`, this.treino[`h_${fields[key]}`]);

                if (this.treino.child) {
                    frmDt.append(
                        `child[${key}]`,
                        this.treino.child[fields[key]],
                    );
                    frmDt.append(
                        `child[h_${key}]`,
                        this.treino.child[`h_${fields[key]}`],
                    );
                }
            }

            frmDt.delete("colors");
            frmDt.append("usergif", this.treino.usergif ? 1 : 0);
            if (this.treino.child) {
                frmDt.append(
                    "child[usergif]",
                    this.treino.child.usergif ? 1 : 0,
                );
            }
            Object.keys(this.treino.colors).forEach((key) => {
                frmDt.append(`colors[${key}][0]`, this.treino.colors[key][0]);
                frmDt.append(`colors[${key}][1]`, this.treino.colors[key][1]);
            });

            if (this.treino.child && this.treino.child.colors) {
                Object.keys(this.treino.child.colors).forEach((key) => {
                    frmDt.append(
                        `child[colors][${key}][0]`,
                        this.treino.child.colors[key][0],
                    );
                    frmDt.append(
                        `child[colors][${key}][1]`,
                        this.treino.child.colors[key][1],
                    );
                });
            }
            if (this.isProfile) {
                this.images.forEach((img, i) =>
                    frmDt.append(`images[${i}]`, img),
                );
            }

            frmDt.append("fitnes_id", this.treino.fitnes_id);

            const response = await this.post({
                url: "fitnesex",
                formData: frmDt,
                data: frmDt,
            });
            if (response.status == 200) {
                alert(t("gifs.created"));
                this.$router.push("/video-sessions/" + this.treino.fitnes_id);
            } else {
                alert(response.data.message);
            }
            this.SET_LOADING(false);
        },
    },
};
</script>

<style lang="scss" scoped></style>
